var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlockQuote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-99.000000, -749.000000)",
    fill: "#FFD47C"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.000000, 769.000000) rotate(-17.000000) translate(-114.000000, -769.000000) translate(96.000000, 746.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9838046,43.8314272 C9.69543387,39.4138732 20.4588158,15.7232485 32.3326309,13.1347863 C35.7365348,12.3927438 24.2721753,48.2489812 16.9838046,43.8314272 Z",
    transform: "translate(23.781060, 28.666029) rotate(9.000000) translate(-23.781060, -28.666029) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34840264,35.2184143 C-1.51427272,32.6229072 9.46578318,4.28552661 19.0703993,1.60390573 C20.9159991,1.08861194 14.211078,37.8139213 6.34840264,35.2184143 Z",
    transform: "translate(11.521487, 18.474168) rotate(11.000000) translate(-11.521487, -18.474168) "
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlockQuote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/block-quote.e6c2d41bc3308c0e428244c4767d381b.svg";